<template>
  <v-dialog max-width="500px" v-model="inDialog" @click:outside="onClickOutside" persistent>
    <v-card>
      <v-form ref="viewPresentForm">
        <div class="headline dialog-header">
          <v-toolbar color="primary" dark>
            <v-toolbar-title style="padding-left: 10px">{{
                $t(formCreateName)
              }}
            </v-toolbar-title>
          </v-toolbar>
          <v-btn
              @click="onCancel"
              icon
              style="position: absolute; right: 10px; top: 10px; color: #fff"
          >
            <v-icon>cancel</v-icon>
          </v-btn>
        </div>

        <v-card-text>
          <v-layout wrap>
            <v-flex xs12>
              <i-datepicker
                  :label="$t('Ngày list')"
                  v-model="item.listDate"
                  :defaultValue="item.listDate ? true : false"
                  :minDate="checkMinDate(item.listDate)"
                  @clearText="clearDropDate"
                  clearable
              />
            </v-flex>
            <v-flex xs12>
              <i-datepicker
                  :label="$t('Ngày phụ huynh gửi video')"
                  v-model="item.listDatePhVideo"
                  :defaultValue="item.listDatePhVideo ? true : false"
                  :minDate="checkMinDate(item.listDatePhVideo)"
                  @clearText="clearDropDate"
                  clearable
              />
            </v-flex>
            <v-flex xs12>
              <v-text-field
                  type="text"
                  :label="$t('Giáo viên list')"
                  v-model.trim="item.listTeacher"
                  name="listTeacher"
                  maxLength="250"
                  :error-messages="errors.first('listTeacher')"
                  :data-vv-as="$t('Giáo viên list')"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                  type="text"
                  :label="$t('Mã lớp')"
                  v-model.trim="item.classCode"
                  name="classCode"
                  maxLength="250"
                  :error-messages="errors.first('classCode')"
                  :data-vv-as="$t('Mã lớp')"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                  type="text"
                  :label="$t('Hà Anh')"
                  v-model.trim="item.haAnh"
                  name="haAnh"
                  maxLength="250"
                  :error-messages="errors.first('haAnh')"
                  :data-vv-as="$t('Hà Anh')"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                  type="text"
                  :label="$t('Tên zalo PH')"
                  v-model.trim="item.nameZaloPh"
                  name="nameZaloPh"
                  maxLength="200"
                  :error-messages="errors.first('nameZaloPh')"
                  :data-vv-as="$t('Tên zalo PH')"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                  type="text"
                  :label="$t('Link video')"
                  v-model.trim="item.linkVideo"
                  name="linkVideo"
                  maxLength="200"
                  :error-messages="errors.first('linkVideo')"
                  :data-vv-as="$t('Link video')"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <i-datepicker
                  :label="$t('Ngày phụ nhận xét')"
                  v-model="item.dateReview"
                  :defaultValue="item.dateReview ? true : false"
                  :minDate="checkMinDate(item.dateReview)"
                  @clearText="clearDropDate"
                  clearable
              />
            </v-flex>
            <v-flex xs12>
              <v-text-field
                  type="text"
                  :label="$t('Giáo viên nhận xét')"
                  v-model.trim="item.teacherReview"
                  name="teacherReview"
                  maxLength="200"
                  :error-messages="errors.first('teacherReview')"
                  :data-vv-as="$t('Giáo viên nhận xét')"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                  type="text"
                  :label="$t('Nhiệm vụ')"
                  v-model.trim="item.missionName"
                  name="missionName"
                  maxLength="200"
                  :error-messages="errors.first('missionName')"
                  :data-vv-as="$t('Nhiệm vụ')"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                  type="text"
                  :label="$t('Nhận xét')"
                  v-model.trim="item.noteReview"
                  name="noteReview"
                  maxLength="200"
                  :error-messages="errors.first('noteReview')"
                  :data-vv-as="$t('Nhận xét')"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                  type="text"
                  :label="$t('Đã gửi text và voice')"
                  v-model.trim="item.statusReview"
                  name="statusReview"
                  maxLength="200"
                  :error-messages="errors.first('statusReview')"
                  :data-vv-as="$t('Đã gửi text và voice')"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <i-datepicker
                  :label="$t('Ngày gửi vào nhóm lớp')"
                  v-model="item.dateSendReview"
                  :defaultValue="item.dateSendReview ? true : false"
                  :minDate="checkMinDate(item.dateSendReview)"
                  @clearText="clearDropDate"
                  clearable
              />
            </v-flex>
            <v-flex xs12>
              <v-text-field
                  type="text"
                  :label="$t('Giáo viên gửi vào nhóm lớp')"
                  v-model.trim="item.teacherSend"
                  name="teacherSend"
                  maxLength="200"
                  :error-messages="errors.first('teacherSend')"
                  :data-vv-as="$t('Giáo viên gửi vào nhóm lớp')"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-form>
      <div style="text-align: right">
        <v-btn color="primary" @click="onSave">
          <v-icon dark left>save</v-icon>
          {{ $t("lang.common.save") }}
        </v-btn>
        <v-btn color="error" @click="onCancel">
          <v-icon dark left>cancel</v-icon>
          {{ $t("lang.common.cancel") }}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import {message} from "../../../services";
import axios from "axios";
import {areaContants} from "@/constants";
import moment from "moment";

export default {
  name: "material-type-group-create",
  components: {message, axios},
  props: {
    propsItem: {
      type: Object,
      default: () => {
        return {}
      }
    },
    cDialog: {
      type: Boolean,
      default: false,
    },
    formCreateName: {
      type: String,
      default: '',
    },
    levels: {
      type: Array,
      default: [],
    },

    ages: {
      type: Array,
      default: [],
    },
  },
  data: () => {
    return {
      areaStatus: areaContants.areaStatus,
      item: {
        listDate: "",
        listDatePhVideo: "",
        listTeacher: "",
        classCode: "",
        haAnh: "",
        nameZaloPh: "",
        linkVideo: "",
        dateReview: "",
        teacherReview: "",
        missionName: "",
        accountId: "",
        noteReview: "",
        statusReview: "",
        dateSendReview: "",
        teacherSend: "",
      },
      inDialog: false,
    };
  },
  watch: {
    propsItem: {
      handler(value) {
        //console.log(value);
        if (value !== null) {
          this.item = {
            missionReviewId: value.missionReviewId,
            listDate: value.listDate
                ? value.listDate
                : "",
            listDatePhVideo: value.listDatePhVideo
                ? value.listDatePhVideo
                : "",
            listTeacher: value.listTeacher
                ? value.listTeacher
                : "",
            classCode: value.classCode
                ? value.classCode
                : "",
            haAnh: value.haAnh
                ? value.haAnh
                : "",
            nameZaloPh: value.nameZaloPh
                ? value.nameZaloPh
                : "",
            linkVideo: value.linkVideo
                ? value.linkVideo
                : "",
            dateReview: value.dateReview
                ? value.dateReview
                : "",
            teacherReview: value.teacherReview
                ? value.teacherReview
                : "",
            missionName: value.missionName
                ? value.missionName
                : "",
            noteReview: value.noteReview
                ? value.noteReview
                : "",
            statusReview: value.statusReview
                ? value.statusReview
                : "",
            dateSendReview: value.dateSendReview
                ? value.dateSendReview
                : "",
            teacherSend: value.teacherSend
                ? value.teacherSend
                : "",
            status: value.status ? value.status : 0,
          };
        } else {
          this.resetFrom();
        }
      },
      deep: true,
    },
    cDialog(value) {
      this.inDialog = value;
    },
    inDialog(value) {
      if (!value) {
        this.$emit("closeCreateDialog", "");
      }
    },
  },
  methods: {
    clearDropDate() {
      this.item.listDate = '';
      this.item.listDatePhVideo = '';
      this.item.dateReview = '';
      this.item.dateSendReview = '';
    },
    checkMinDate(minDate = moment()) {
      if (minDate == '' || minDate == null) minDate = moment();
      let minDate_tmp = moment(String(minDate));
      let today = moment();
      // if (minDate_tmp <= today) {
      //     minDate = moment().format('YYYY-MM-DD');
      // } else {
      minDate = minDate_tmp.format('YYYY-MM-DD');
      // }
      return minDate;
    },
    resetFrom: function () {
      this.item = {
        listDate: "",
        listDatePhVideo: "",
        listTeacher: "",
        classCode: "",
        haAnh: "",
        nameZaloPh: "",
        linkVideo: "",
        dateReview: "",
        teacherReview: "",
        missionName: "",
        accountId: "",
        noteReview: "",
        statusReview: "",
        dateSendReview: "",
        teacherSend: "",
      };
    },
    levelChange(levelId) {
      this.getNextCode();
    },
    getNextCode: function () {
      axios.post(
          process.env.VUE_APP_API_URL + "/kidLevel/listAllName", {status: 1}
      )
          .then((data) => {
            this.item = Object.assign({}, this.item, {"code": data})
          });
    },
    onCancel: function () {
      this.$emit("closeCreateDialog", "");
    },
    onSave: function () {
      // console.log(this.item);
      this.$validator.validate().then((valid) => {
        if (!valid) {
          message.error(this.$t("lang.common.validate_fail"));
          return;
        }
        axios
            .post(
                process.env.VUE_APP_API_URL +
                "/kidMissionReview/save",
                this.item
            )
            .then(
                (data) => {
                  if (data.success) {
                    message.success(
                        this.$t("lang.common.save_success")
                    );
                    this.resetFrom();
                    this.onCancel();
                  } else {
                    let msg = data.description;
                    if (data.description === 'lang.category.duplicateCode') {
                      msg = 'lang.materialTypeGroup.duplicateCode';
                    } else if (data.description === 'lang.category.duplicateName') {
                      msg = 'lang.materialTypeGroup.duplicateCode';
                    }
                    message.error(this.$t(msg));
                  }
                },
                (error) => {
                  console.log(error);
                }
            );
      });
    },

  },
  created() {
  },
};
</script>
